var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultHead = function SvgDefaultHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25282C",
    d: "M0 0h32v32H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.361 19.372H5V13.73h2.266c1.101 0 1.743.618 1.743 1.585 0 .626-.412 1.03-.697 1.165.341.158.777.515.777 1.268 0 1.053-.722 1.624-1.728 1.624m-.182-4.66H6.1v1.3H7.18c.467 0 .729-.26.729-.65 0-.387-.262-.65-.73-.65m.071 2.291H6.101v1.387h1.15c.498 0 .737-.318.737-.697 0-.38-.239-.69-.738-.69M12.448 17.058v2.314h-1.093v-2.314L9.659 13.73h1.197l1.053 2.275 1.038-2.274h1.196zM17.266 19.372h-2.362V13.73h2.266c1.101 0 1.743.618 1.743 1.585 0 .626-.411 1.03-.697 1.165.342.158.777.515.777 1.268 0 1.053-.722 1.624-1.727 1.624m-.183-4.66h-1.077v1.3h1.077c.468 0 .729-.26.729-.65 0-.387-.261-.65-.729-.65m.072 2.291h-1.15v1.387h1.15c.498 0 .737-.318.737-.697-.001-.38-.239-.69-.737-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7A600",
    d: "M21.299 12h-1.102v5.641H21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.847 14.713v4.659h-1.101v-4.66h-1.473v-.982h4.048v.982z"
  }))));
};
export default SvgDefaultHead;